import { Outlet } from "react-router-dom";
import { PicklistContextProvider } from "ticketing/contexts/picklists/PicklistContextProvider";
export const PicklistContextLayout = () => {
  return (
    <PicklistContextProvider>
      <Outlet />
    </PicklistContextProvider>
  );
};
